import { analytics } from 'moet-core';

export const ANALYTICS_EVENTS = {
  widgetOpened: new analytics.Event({
    name: 'Chat Widget Opened',
    description: 'User opens the chat widget',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.FRESH_CHAT,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: [],
  }),
  widgetClosed: new analytics.Event({
    name: 'Chat Widget Closed',
    description: 'User closes the chat widget',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.FRESH_CHAT,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: [],
  }),
  chatInitiated: new analytics.Event({
    name: 'Chat Initiated',
    description: 'User starts a chat by sending the first message',
    action: analytics.EVENT_ACTION.FORM_SUBMIT,
    category: analytics.EVENT_CATEGORY.FRESH_CHAT,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: [],
  }),
};
